


var movie = {};

var sequence = {};
var _path = "";
var _staticPath = {
    local: 'https://op-wstatic.ncsoft.com',
    op: 'https://op-wstatic.ncsoft.com',
    rc: 'https://rc-wstatic.plaync.co.kr',
    live: 'https://wstatic-cdn.plaync.com'
};
var staticPath = (function() {
    var loc = location.href;

    var projectPath = '/promo/lineage2/history/2020/201014_collection/';
    _path = _staticPath.live + projectPath;

    if (/rc\.|rc-/i.test(loc)) {
        _path = _staticPath.rc + projectPath;
    }
    if (/opdev\.|opdev-/i.test(loc)) {
        _path = _staticPath.op + projectPath;
    }
    if (/local\.|localhost|opdev\.|ui-static\.|file:/i.test(loc)) {
        _path = _staticPath.local + projectPath;
    }
})();


movie.introMovie = promokit.video({
    el: '#player-intro',
    url: 'https://vod.plaync.com/lineage2/update/17th/main.mp4',
    preload: true,
    mute: true,
    autoplay: true,
    loop: true
});

movie.video1 = promokit.video({
    el: '#tribe-10',
    //url: _path+'img/video/main.mp4',
    url: 'https://vod.plaync.com/lineage2/update/17th/01.mp4',
    poster: _path+'img/17th/poster_0.png',
    controls: true,
    mute: true,
    preload : false
});

movie.video2 = promokit.video({
    el: '#tribe-11',
    url: 'https://vod.plaync.com/lineage2/update/17th/02.mp4',
    poster: _path+'img/17th/poster_1.png',
    controls: true,
    mute: true,
    preload : false
});
movie.video3 = promokit.video({
    el: '#tribe-12',
    url: 'https://vod.plaync.com/lineage2/update/17th/03.mp4',
    poster: _path+'img/17th/poster_2.png',
    controls: true,
    mute: true,
    preload : false
});

movie.video4 = promokit.video({
    el: '#tribe-2',
    url: 'https://vod.plaync.com/lineage2/update/17th/04.mp4',
    //poster: _path+'img/17th/temp_img3.jpg',
    controls: true,
    mute: true,
    preload : false
});

movie.video5 = promokit.video({
    el: '#tribe-3',
    url: 'https://vod.plaync.com/lineage2/update/17th/05.mp4',
    //poster: _path+'img/17th/temp_img3.jpg',
    controls: true,
    mute: true,
    preload : false
});


sequence.seq_main =promokit.sequence({
    el: '#title_seq',
    path: _path+"img/17th/title",
    prefix:"title__",
    frame:120,
    autoplay:true,
    fps:30,
    loop:true,
    preload:true
});
sequence.seq_sylph =promokit.sequence({
    el: '#sylph_seq',
    path: _path+"img/17th/sylph",
    prefix:"sylph_0_",
    frame:120,
    fps:30,
    autoplay:true,
    loop:true,
    preload:true
});









var Aniversary = (function() {



    function Lineage17(opts) {
        this.page;
        this.opts = opts;
        this.selector = {
            box: "[data-scene]"
        };
        this.state = {
            y: [],
            introTimer: null,
            resizeTimer: null,
            isScrolling: false,
            rsp: false
        };
        this.scenebox = {};
        this.movie = {};
        this.layer = {};
        this.slider = {};

        this.init();
    }
    Lineage17.prototype = {
        init : function() {
            //this.setPage();
            this.state.length = $(this.selector.box).length - 1;

            this.setPage();
            //this.setMovie();
            this.setSlide();
            this.mouseWheel();
            this.resize();
            this.setSequence();
            this.sceneSettings();
            this.controls();

            this.setMovie();
            this.layout();
            this.sceneAnimation();
            this.state.isScrolling = false;
            this.setLayer();
            this.setEvent();
        },
        setPage : function () {
            promokit.page({
                game: 'lineage2',
                menu: false,
                cnb: true,

                topButton: true,

                headerButton: {
                    el: '.header-button',
                    cookie: {
                        type: 'year',
                        key: 'INDEX_WEB_VISIT_201014_collection',
                        value: false
                    },
                    home: true,
                    event:false,
                    update:true,
                    sns: true,
                    theme: 'black'
                }
            });
        },
        setMovie : function() {

            movie.video_skill0 = promokit.video({
                el: '#video_skill0',
                url: 'https://vod.plaync.com/lineage2/update/17th/skill1.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });
            movie.video_skill1 = promokit.video({
                el: '#video_skill1',
                url: 'https://vod.plaync.com/lineage2/update/17th/skill2.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });
            movie.video_skill2 = promokit.video({
                el: '#video_skill2',
                url: 'https://vod.plaync.com/lineage2/update/17th/skill3.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });
            movie.video_skill3 = promokit.video({
                el: '#video_skill3',
                url: 'https://vod.plaync.com/lineage2/update/17th/skill4.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });
            movie.video_skill4 = promokit.video({
                el: '#video_skill4',
                url: 'https://vod.plaync.com/lineage2/update/17th/skill5.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });
            movie.video_skill5 = promokit.video({
                el: '#video_skill5',
                url: 'https://vod.plaync.com/lineage2/update/17th/skill6.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });
            movie.video_weapon_bg = promokit.video({
                el: '#bgVideo3',
                url: 'https://vod.plaync.com/lineage2/update/17th/shooter.mp4',
                controls: false,
                loop: true,
                mute: true,
                preload : true
            });


        },
        setLayer : function() {
            var context = this;

            context.layer.collect_layer = promokit.layer({
                el: '#collect_layer',
                render: true
            });

            context.slider.collect_slide = promokit.slide({
                el: '#collect_slide',
                arrow: true,
                infinity: true
            });
            context.slider.collect_slide.on('slidestart', function (index) {
                $('#collect_layer .btnWrap a').removeClass('on');
                $('#collect_layer .btnWrap a').eq(index.to).addClass('on');
            });


            $('.collection_wrap a').on('click', function(){
                var idx = $('.collection_wrap a').index($(this));
                context.layer.collect_layer.open();
                setTimeout(function() {
                    context.slider.collect_slide.to(0, true);
                },10)
            })
            $('#collect_layer .btnWrap a').on('click', function() {
                var idx = $('#collect_layer .btnWrap a').index($(this));
                context.slider.collect_slide.to(idx);
            })
        },
        setEvent : function(){
            var context = this;
            $('#menu a').on('click', function(e) {

                var num = $(this).data('anchor');
                //console.log(123123, $(this).data('anchor'));
                if ($(this).data('anchor') == undefined) {
                    num = $(this).closest('ul').siblings('a').eq(0).data('anchor');
                }
                console.log(num)
                if (context.opts.idx != num && num != undefined) {
                    context.opts.before = context.opts.idx;
                    context.opts.idx = num;
                    context.moveAnimation();
                }
                //console.log(111111 , context.opts.before , context.opts.idx);

                if ($(this).attr('href').substr(0,1) == "#") {
                    return false;
                }




            });
            $('.js-btn_scroll').on('click', function() {
                context.opts.before = 0;
                context.opts.idx = 1;
                context.moveAnimation();
            })
            $('.collection_wrap a').on('click', function() {
                $('.tooltipWrap').fadeOut(300);
            })
            $(window).on('resize', function() {
                var chk = false;
                setTimeout(function() {
                    $('.promokit-video__screen').each(function(){
                        if ($(this).width() != $(this).parent().width()) {
                            chk = true;
                        }
                    })
                    if (chk) $(window).trigger('resize');
                },10);
            })
        },
        setSlide: function() {
            var context = this;
            context.slider.tribeSlide = promokit.slide({
                el: '#slide-1',
                arrow: true,
                infinity: true,
                bullet: true,
                autoplayVideo: {
                    //0: video1,
                    //1: video2
                }
            });
            context.slider.tribeSlide.on('slidestart', function (index) {
                $('.hunter_tab li a').removeClass('on');
                $('.hunter_tab li a').eq(index.to).addClass('on');
            });
            $('.hunter_tab li a').on('click', function() {
                var idx = $('.hunter_tab li a').index($(this));
                context.slider.tribeSlide.to(idx);
            })


            context.slider.tribeSlide2 = promokit.slide({
                el: '#slide-2',
                arrow: true,
                infinity: true,
                bullet: true,
                autoplayVideo: {
                    //0: video1,
                    //1: video2
                }
            });

            context.slider.tribeSlide2.on('slidestart', function(index) {
                $('.concept_tab li a').removeClass('on');
                $('.concept_tab li a').eq(index.to).addClass('on');
            });
            $('.concept_tab li a').on('click', function() {
                var idx = $('.concept_tab li a').index($(this));
                context.slider.tribeSlide2.to(idx);
            })


            context.slider.tribe_swiper = new Swiper('.tribe_cont', {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove : false,
                noSwiping: false,
                simulateTouch: false,
                speed: 300,
                spaceBetween: 100
            });
            $('#tribe .tab_btn li a').on('click', function() {
                if ($(this).attr('href')== "#") {
                    $('#tribe .tab_btn li').removeClass('on');
                    var idx = $('#tribe .tab_btn li a').index($(this));
                    $('#tribe .tab_btn li').eq(idx).addClass('on');
                    context.slider.tribe_swiper.slideTo(idx);
                    return false;
                }
            })


            context.slider.skill_swiper = new Swiper('.skill_cont', {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },

                allowTouchMove : false,
                noSwiping: false,
                simulateTouch: false,
                speed: 300,
                spaceBetween: 100
            });


            context.slider.skill_swiper.on('slideChangeTransitionStart', function (e) {
                var _video = $(context.slider.skill_swiper.slides[context.slider.skill_swiper.activeIndex]).find('.bg').attr('id');
                movie[_video].seek(0);
                movie[_video].play();

            });
            context.slider.skill_swiper.on('slideChangeTransitionEnd', function (e) {
                for (var i=0; i<context.slider.skill_swiper.slides.length; i++) {
                    if (i != context.slider.skill_swiper.activeIndex) {
                        var _video = $(context.slider.skill_swiper.slides[i]).find('.bg').attr('id');
                        movie[_video].stop();
                    }
                }
            });
            $('#skill .tab_btn li a').on('click', function() {
                $('#skill .tab_btn li').removeClass('on');
                var idx = $('#skill .tab_btn li a').index($(this));
                $('#skill .tab_btn li').eq(idx).addClass('on');
                context.slider.skill_swiper.slideTo(idx);

            })


        },
        sceneSettings: function() {
            $('#intro').addClass('page_active');

        },
        setSequence : function() {



        },
        controls: function() {
        },
        remote: function(target) {

            var $menu = $('#menu');
            var $bullet = $menu.find('a[data-anchor]');
            $menu.find('a').removeClass('on');
            $bullet.removeClass('on').eq(target ).addClass('on');

            var _ul = $bullet.eq(target).closest('ul');
            if (_ul.length) {
                _ul.siblings('a').addClass('on');
            }
            $menu.removeClass().addClass('active-' + target);

        },
        resize: function() {
            var context = this;
            $(window).resize(function() {
                sh = $(window).height();
                if (context.state.resizeTimer) {
                    clearTimeout(context.state.resizeTimer);
                }
                context.state.resizeTimer = setTimeout(function() {
                    context.state.resizeTimer = null;
                    context.layout();
                }, 100);
            }).resize();
        },
        mouseWheel: function() {
            var context = this;
            $(this.opts.el).on("mousewheel DOMMouseScroll", function(e) {
                context.wheelDelta(e);
            });
        },
        getwheelDelta: function(e) {
            if (e.type == "DOMMouseScroll") return e.originalEvent.detail < 0 ? 1 : -1;
            if (e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY < 0 ? -1 : 1;
            return e.originalEvent.wheelDelta < 0 ? -1 : 1;
        },
        wheelDelta: function(e) {
            var context = this;

            if (!context.state.isScrolling) {
                context.state.isScrolling = true;
                if (context.getwheelDelta(e) < 0) {
                    this.scrollDown();
                } else {
                    this.scrollUp();
                }
                setTimeout(function() {
                    context.state.isScrolling = false;
                }, context.opts.wheelsp);
            }
            return false;
        },
        moveAnimation: function() {

            for (var i = 0; i < this.state.length + 1; i++) {
                if (this.opts.idx == i) {
                    if (this.opts.before > this.opts.idx) {
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(this.opts.before))], 1.2, {  y: '0%', zIndex: '1' }, { y: '100%', zIndex: '1', ease: Power4.easeInOut  });
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 1.2, { y: '-100%', zIndex: '1' }, { y: '0%', zIndex: '1', ease: Power4.easeInOut });
                    } else if (this.opts.before < this.opts.idx) {
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(this.opts.before))], 1.2, { y: '0%', zIndex: '1' }, { y: '-100%', zIndex: '1', ease: Power4.easeInOut  });
                        TweenMax.fromTo([$(this.opts.el).find($(this.selector.box).eq(i))], 1.2, { y: '100%', zIndex: '1' }, { y: '0%', zIndex: '1', ease: Power4.easeInOut });
                    }
                } else if (this.opts.before == i) {
                    TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(i))], 0, { zIndex: 8, y: '0%' });
                } else {
                    TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(i))], 0, { zIndex: '', y: '0%' });
                }
            }
            this.sceneAnimation();
        },

        layout: function() {
            TweenMax.to([$("#container")], 0, { autoAlpha: 1 });
            TweenMax.to([$(this.opts.el).find($(this.selector.box))], 0, { autoAlpha: 1, y: '0%' });
            TweenMax.to([$(this.opts.el).find($(this.selector.box).eq(this.opts.idx))], 0, { autoAlpha: 1, y: '0%', zIndex: 10 });
        },
        scrollDown: function() {
            if (this.opts.idx < this.state.length) {
                this.opts.before = this.opts.idx;
                this.opts.idx = this.opts.idx + 1;
            } else if (this.opts.idx == this.state.length) {
                return false;
            }

            this.moveAnimation();
        },
        scrollUp: function() {


            if (this.opts.idx > 0) {
                this.opts.before = this.opts.idx;
                this.opts.idx = this.opts.idx - 1;
            } else if (this.opts.idx == 0) {
                return false;
            }
            this.moveAnimation();
        },

        sceneAnimation: function() {
            var context = this;
            context.remote(this.opts.idx);
            setTimeout(function() {
                $('.section').removeClass('page_active');
                $('.section').eq(context.opts.idx).addClass('page_active');

                $.each(movie, function(index, value) {
                    this.stop();
                    if (this.stopVideo) { this.stop();}
                });
                $.each(context.sequence, function(index, value) {
                    this.stop();
                });
                if (context.opts.idx == 0) {
                    movie.introMovie.seek(0);
                    movie.introMovie.play();
                    movie.introMovie.stopVideo = false;
                    sequence.seq_main.play();
                }
                if (context.opts.idx == 1) {
                    sequence.seq_sylph.play();
                }
                if (context.opts.idx == 3) {
                    var _id = $('.skill_cont li').eq(context.slider.skill_swiper.activeIndex).find('.player').attr('id');
                    var bg_video = movie[_id];
                    bg_video.seek(0);
                    bg_video.play();
                }
                if (context.opts.idx == 4) {
                    movie.video_weapon_bg.seek(0);
                    movie.video_weapon_bg.play();
                }
            },1000);

        }

    }
    return Lineage17;

})();


promokit.preload({
    game: 'lineage2',
    complete: function () {

        window.promo_aniv = new Aniversary({
            el: "#scene-box",
            idx: 0,
            before: 0,
            wheelsp: 1200
        });
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js